import React from "react";
import { Row, Col, Spinner, Alert } from "reactstrap";
import useManagerDashboard from "../Manager/hooks/useManagerDashboard";
import StatCardAdvance from "./components/StatCardAdvance";
import RevenueExpenseChart from "./components/charts/RevenueExpenseChart";

const FinancialDashboard = () => {
    // In a real scenario, this hook should provide these financial metrics.
    // For now, we use the existing one and mock the missing parts as requested.
    const { loading, error, data } = useManagerDashboard();

    if (loading) {
        return (
            <div className="text-center py-5">
                <Spinner color="primary" />
                <p className="text-muted mt-2">Carregando métricas financeiras...</p>
            </div>
        );
    }

    if (error) {
        return (
            <Alert color="danger">
                <i className="mdi mdi-alert-circle-outline me-2"></i>
                Erro ao carregar dados: {error}
            </Alert>
        );
    }


    return (
        <React.Fragment>
            <div className="d-flex justify-content-end align-items-center pt-2 mb-4">
            </div>

            {/* ── KPIs Principais ── */}
            <Row className="align-items-stretch">
                <Col md={4} sm={12} className="mb-4">
                    <StatCardAdvance
                        title="Vendas Hoje"
                        currentValue={data.salesTodayGross || 0}
                        previousValue={0} // Este pode virar comparison real depois
                        subtitle={`${data.salesTodayCount || 0} vendas realizadas`}
                        icon="mdi mdi-cart-outline"
                        isCurrency={true}
                    />
                </Col>
                <Col md={4} sm={12} className="mb-4">
                    <StatCardAdvance
                        title="Vendas (Mês)"
                        currentValue={data.salesMonthGross || 0}
                        previousValue={data.previousSalesMonthGross || 0}
                        subtitle={`${data.salesMonthCount || 0} vendas no período`}
                        icon="mdi mdi-cart-check"
                        isCurrency={true}
                    />
                </Col>
                <Col md={4} sm={12} className="mb-4">
                    <StatCardAdvance
                        title="Despesas (Mês)"
                        currentValue={data.expenseMonth || 0}
                        previousValue={data.previousExpenseMonth || 0}
                        subtitle="Gastos fixos e variáveis"
                        icon="mdi mdi-trending-down"
                        isCurrency={true}
                    />
                </Col>
            </Row>

            {/* ── Gráfico Analítico ── */}
            <Row>
                <Col md={12}>
                    <RevenueExpenseChart data={data.financialChartData || []} />
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default FinancialDashboard;
